// @flow

import React, { Component } from 'react';
import { parse } from 'query-string';
import Scrollspy from 'react-scrollspy';
import { StepsComponent as StyledSteps } from './steps.styled';
import { Step } from './atoms';
import type { StepProps, StepsProps } from '../../types';
import scrollToAnchor from '../../../../helpers/scrollToAnchor';

// function for smooth scrolling
// the container- prefix is to prevent default browser functionality
// in component configBuilderGroup.container the container- prefix is also set.
const onStepClick = e => scrollToAnchor({ anchorId: `container-${e}` });
class Steps extends Component<StepsProps> {
  componentDidMount() {
    // If there is a pre selected package in the url (?pkg=) than page
    // should start at the first config section and not on top of the package
    // TODO no more window, needs to come from react router if the router is fixed.
    // Ticket for TODO: https://justlease.atlassian.net/browse/WPW-558
    const { search } = window.location;
    const params = parse(search);
    if (params.pkg) {
      const firstStepElement = document.querySelector('.step-1');
      if (firstStepElement) {
        scrollToAnchor({ anchorId: firstStepElement && firstStepElement.id });
      }
    }
  }

  render() {
    const { steps } = this.props;

    return (
      <StyledSteps>
        <Scrollspy
          componentTag="div"
          currentClassName="active"
          items={steps.map(step => `container-${step.id}`)}
          offset={-96}
        >
          {steps.map((step: StepProps) => (
            <Step
              onClick={() => { onStepClick(step.id) }}
              key={`step-${step.id}`}
              href={`#${step.id}`}
              id={step.id}
              isActive={false}
            >
              {step.label}
            </Step>
          ))}
        </Scrollspy>
      </StyledSteps>
    );
  }
}

export default Steps;
